import { render, staticRenderFns } from "./RiskAssessmentEvalTableList.vue?vue&type=template&id=6c0a20f8&"
import script from "./RiskAssessmentEvalTableList.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentEvalTableList.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentEvalTableList.vue?vue&type=style&index=0&id=6c0a20f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports